import { PUBLISH_STATUS } from 'constants/content/content';

interface ICollectionLab {
  status?: string;
}

/**
 * The labs of a collection that actually count for a learner.
 *
 * The playlist API hydrates a collection's `labs` array unfiltered on
 * purpose -- the content picker and preview need draft labs visible too --
 * but RFC §3.2 defines a collection's *eligible* labs as its published ones,
 * and everything a learner is measured against is built on that: the
 * completion rule, the `total_labs` summary, the `x/y labs` display ratio,
 * and the CSV report's child-lab rows. Anything rendering per-learner
 * progress has to apply the same filter or it disagrees with all of them.
 *
 * A lab whose `status` is missing is treated as eligible rather than
 * dropped: an older cached payload without the field should degrade to
 * today's behaviour, not make every lab in the collection disappear.
 */
export const getEligibleCollectionLabs = <T extends ICollectionLab>(labs: T[] = []): T[] =>
  labs.filter(({ status }) => status === undefined || status === PUBLISH_STATUS.PUBLISHED);

export default getEligibleCollectionLabs;
